import React from 'react';
import PropTypes from 'prop-types';
import { Link, withPrefix } from 'gatsby';

import { httpUrl, localUrl } from '../../utils/regex';

function LinkOrAnchor({ url, text }) {
  const styles =
    'inline-block text-sm text-base-content hover:text-accent no-underline hover:underline hover:decoration-1 border-0';

  if (httpUrl.test(url)) {
    return (
      <a
        href={url}
        title={text}
        target='_blank'
        rel='noopener'
        className={styles}
      >
        {text}
      </a>
    );
  }

  if (localUrl.test(url)) {
    return (
      <Link to={withPrefix(url)} title={text} className={styles}>
        {text}
      </Link>
    );
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <></>;
}

LinkOrAnchor.propTypes = {
  url: PropTypes.string,
  text: PropTypes.string,
};

function StatesList({ heading, data, className, singleColumn }) {
  return (
    <div className={className}>
      <h2 className='text-2xl font-bold uppercase'>{heading}</h2>
      <div
        className={`columns-1 ${!singleColumn && 'md:columns-3'} m-0 gap-6 space-y-4`}
      >
        {data.map(({ key, linkText, linkUrl }) => (
          <div key={key}>
            <LinkOrAnchor url={linkUrl} text={linkText} />
          </div>
        ))}
      </div>
    </div>
  );
}

StatesList.propTypes = {
  heading: PropTypes.string,
  className: PropTypes.string,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      linkText: PropTypes.string,
      linkUrl: PropTypes.string,
    })
  ).isRequired,
  singleColumn: PropTypes.bool,
};

export default StatesList;
